"use client";

import { Config, Post, PropertyType, Template } from "src/types";
import { useTheme } from "../../contexts/useTheme";

// ✅ Manual imports
import AnnouncementPageDesign1 from "../design1/AnnouncementPostPage";
import AnnouncementPageDesign2 from "../design2/AnnouncementPostPage2";
import AnnouncementPageDesign3 from "../design3/Pages/AnnouncementPostPage3";

type Props = {
  post: Post;
  properties: PropertyType[];
  serverConfig: Config;
};

const AnnouncementPageSwitch = ({
  post,
  properties,
  serverConfig,
}: Props) => {
  const { config } = useTheme();
  const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

  const template: Template | undefined = isDemoMode
    ? config?.template
    : serverConfig.template;

  let SelectedComponent;

  switch (template) {
    case "design1":
      SelectedComponent = AnnouncementPageDesign1;
      break;
    case "design2":
      SelectedComponent = AnnouncementPageDesign2;
      break;
    default:
      SelectedComponent = AnnouncementPageDesign3;
      break;
  }

  return (
    <SelectedComponent
      post={post}
      listings={properties}
      
    />
  );
};

export default AnnouncementPageSwitch;
